<template>
  <div>
    <page-title v-if="item" :title="pageTitle" />
    <subscription-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel" :is-editable="isEditable">
      <template v-slot:save>Add</template>
    </subscription-fields>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "SubscriptionAdd",
  mixins: [CrudOperationsMixin],
  props: [
    'applicationUserId',
    'userName'
  ],
  data() {
    return {
      isUserNameFixed: false,
      item: {
        station: {
          id: null,
        },
        applicationUser: {
          id: this.applicationUserId,
          userName: '',
        },
        type: 'NO_EMAIL'
      }
    };
  },
  computed: {
    pageTitle: function () {
      return 'Add New Subscription';
    },
    isEditable: function () {
      return this.$root.$data.authenticatedUser.roles.some(x => x == "SiteAdmin") || this.$root.$data.authenticatedUser.stationRoles.some(x => x.station.id == this.stationId && x.type == "STATION_HEAD");
    }
  },
  methods: {
    loadApplicationUser() {
      this.readQuery('/graphql/management', {
          query: `
            query ($id: ID) {
              applicationUser (id: $id) {
                id,
                email,
                userName
              }
            }`,
          variables: {
            'id': this.item.applicationUser.id
          }
        }, (data) => {
          if (data.applicationUser) {
            console.log('Setting user: ' + data.applicationUser.userName);
            this.item.applicationUser.id = data.applicationUser.id;
            this.item.applicationUser.userName = data.applicationUser.userName;
          }
        });
    },
    goBack() {
      this.$router.push('/applicationUser/' + this.item.applicationUser.id + '#subscriptions');
    },
    onCancel(evt) {
      this.goBack();
    },
    onSubmit(evt) {
      this.updateQuery('/graphql/management', {
        query: `
          mutation ($subscription: SubscriptionCreateInputOGT!) {
            createSubscription(subscription: $subscription) {
              id
            }
          }`,
        variables: {
          'subscription': {
            stationId: this.item.station.id,
            applicationUserId: this.item.applicationUser.id,
            trigger: this.item.trigger,
            displayWeight: 0
          }
        }}, () => {
          this.goBack();
        }, null, 'Subscriptions', this.item.applicationUser.userName);
    },
  },
  mounted () {
    this.loadApplicationUser();
  }
};
</script>